const worldDownloadCountrys = [
      "Slovakia",
      "Czech Republic",
      "Rumania",
      "Bulgaria",
      "Malta",
      "Greece",
      "Belgium",
      "Poland",
      "Hungary",
      "Philippines",
];

export const logoLinkMixin = {
  data: {
    worldDownloadCountrys
  },
  computed: {
    isWorldDownloadCountry() {
      return worldDownloadCountrys.includes(this.platform);
    },
    logoLink() {
      return this.isWorldDownloadCountry
        ? "https://kkpoker.world/"
        : this.globalConfig.kkLogoLink;
    },
  },
};
